import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../customer.service';
import { CustomerComponentData } from '../customer.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-customer-app-bar-title',
    templateUrl: './customer-app-bar-title.component.html',
    styleUrls: ['./customer-app-bar-title.component.scss'],
    standalone: false
})
export class CustomerAppBarTitleComponent implements OnInit {

  title: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService) { }

  backToCustomerList() {
    this.router.navigateByUrl(this.customerService.prevCustomerListUrl || '/customer');
  }

  backToCustomerDetails() {
    this.router.navigateByUrl(`/customer/${this.data.customer.id}/profile`);
  }

  data: CustomerComponentData;

  dataSet(data: CustomerComponentData) {
    this.data = data;
    this.title = data.customer ? `${data.customer.firstName || ''} ${data.customer.lastName || ''}` : '';
  }

  ngOnInit() {
  this.route.data.pipe(untilDestroyed(this))
      .subscribe(this.dataSet.bind(this));
  }

}
